module.exports = __webpack_public_path__ + "img/f31962262d9b496f3407b5a05de75697.77178733.png";